export default {

  // The unique name for the local storage variable that persists the state of
  // the vuex storage.
  localStorageId: 'clavis',
}
